interface Dictionary {
  [key: string]: string;
}

export const InputErrorMessageDictionary: Dictionary = {
  required: `Campo obligatorio.`,
  email: `Correo electrónico inválido.`,
  minlength: `Caracteres mínimos: {{ requiredLength }}`,
  maxlength: `Caracteres máximos: {{ requiredLength }}`,
  min: `Mínimo: {{ min }}`,
  max: `Máximo: {{ max }}`,
  pattern: `Patrón: {{ requiredPattern }}`,
  requiredTrue: `Campo obligatorio.`,
  matchPassword: `Las contraseñas no coinciden`,
  checkTime: `Debe ser mayor a la hora incial.`,
  custom: ``,
};
